import React from 'react';
import glamorous from 'glamorous';
import MdKeyboardArrowLeft from 'react-icons/lib/md/keyboard-arrow-left';
import MdKeyboardArrowRight from 'react-icons/lib/md/keyboard-arrow-right';

import Body from '../typography/Body';
import Button from '../ui/Button';
import ButtonGroup from '../ui/ButtonGroup';

import StickersheetRow from './StickersheetRow';

const colors = [
  'default',
  'primary',
  'secondary',
  'accent',
];

const sizes = [
  'small',
  'default',
  'large',
];

const style = {
  marginRight: 8,
  marginBottom: 16,
};

const styleTitle = {
  marginBottom: 16,
  textTransform: 'capitalize',
};

const Row = glamorous.div({
  display: 'flex',
  flexWrap: 'wrap',
});

export default () => (
  <StickersheetRow title="Buttons">
    {
      sizes.map((size) => (
        <div key={size}>
          <Body style={styleTitle}>{size}</Body>
          <Row>
            {
              colors.map(color => (
                <Button
                  key={`${size}:${color}`}
                  label={color}
                  size={size}
                  color={color}
                  style={style}
                />
              ))
            }
          </Row>
        </div>
      ))
    }
    <div>
      <Body style={styleTitle}>Disabled</Body>
      <Row>
        {
          colors.map(color => (
            <Button
              disabled
              key={color}
              label={color}
              color={color}
              style={style}
            />
          ))
        }
      </Row>
    </div>
    <div>
      <Body style={styleTitle}>Icons</Body>
      <Row>
        <Button
          label="Left"
          style={style}
          leftIcon={<MdKeyboardArrowLeft size={24} />}
        />
        <Button
          label="Right"
          style={style}
          rightIcon={<MdKeyboardArrowRight size={24} />}
        />
        <Button
          label="Both"
          style={style}
          leftIcon={<MdKeyboardArrowLeft size={24} />}
          rightIcon={<MdKeyboardArrowRight size={24} />}
        />
      </Row>
    </div>
    <div>
      <Body style={styleTitle}>Button Group</Body>
      <Row>
        <ButtonGroup>
          <Button
            label="Btn 1"
          />
          <Button
            label="Btn 2"
          />
          <Button
            label="Btn 3"
          />
        </ButtonGroup>
      </Row>
    </div>
  </StickersheetRow>
);



// WEBPACK FOOTER //
// ./src/components/demo/Buttons.js